import React from "react";
import { useNavigate } from "react-router-dom";
import { Eye, Star, Ribbon, CheckCircle2 } from "lucide-react";
import { StatusPill } from "./StatusPill";

export function ShowCard({ show }) {
  const navigate = useNavigate();
  return (
    <div
      className="show-card fade-up"
      onClick={() => navigate(`/show/${show.id}`)}
      data-testid={`show-card-${show.id}`}
    >
      <div className="show-thumb">
        <img src={show.thumbnail} alt={show.title} loading="lazy" />
        <div className="show-thumb-overlay" />

        {/* top row: live badge (left) + viewers (right) */}
        <div className="show-tags">
          {show.status === "live"
            ? <span className="tag tag-live"><span className="ss-dot" style={{ background: "#fff" }} />Live</span>
            : <StatusPill status={show.status} />}
        </div>
        {show.status === "live" && (
          <div style={{ position: "absolute", top: 12, right: 12 }}>
            <span className="tag" style={{ background: "rgba(0,0,0,.5)", color: "#fff" }}><Eye size={12} /> {show.viewer_count?.toLocaleString()}</span>
          </div>
        )}

        {/* bottom row over image: category + verified + featured + founding */}
        <div style={{ position: "absolute", bottom: 12, left: 12, right: 12, display: "flex", gap: 6, flexWrap: "wrap" }}>
          <span className="tag" style={{ background: "var(--gold)", color: "var(--brand-2)" }}>{show.category}</span>
          {show.seller_verified && (
            <span className="tag" data-testid={`card-verified-${show.id}`} style={{ background: "var(--brand, #0c4a38)", color: "#fff", display: "inline-flex", alignItems: "center", gap: 4 }}>
              <CheckCircle2 size={11} /> Verified
            </span>
          )}
          {show.featured && <span className="tag tag-founding"><Star size={11} /> Featured</span>}
          {show.seller_founding && <span className="tag tag-founding"><Ribbon size={11} /> Founding{show.seller_founding_number ? ` #${show.seller_founding_number}` : ""}</span>}
        </div>
      </div>

      <div className="show-body">
        <div className="show-title">{show.title}</div>
        <div className="show-seller" onClick={(e) => { e.stopPropagation(); navigate(`/store/${show.seller_id}`); }} style={{ cursor: "pointer" }} data-testid={`card-seller-${show.id}`}>
          <img src={show.seller_avatar} alt={show.seller_name} />
          <span className="show-seller-name">{show.seller_name}</span>
          {show.seller_verified && <CheckCircle2 size={15} className="badge-verified" />}
          {show.seller_founding && <Ribbon size={14} style={{ color: "var(--gold)" }} />}
          {show.seller_review_count > 0 && (
            <span data-testid={`card-rating-${show.id}`} style={{ marginLeft: "auto", display: "inline-flex", alignItems: "center", gap: 3, fontSize: 13, fontWeight: 700 }}>
              <Star size={13} style={{ color: "var(--gold)" }} fill="var(--gold)" /> {show.seller_rating?.toFixed(1)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
